import { Controller } from "@hotwired/stimulus"

import ace from "ace-builds/src-noconflict/ace"
import "ace-builds/src-noconflict/mode-text"
import "ace-builds/src-noconflict/theme-chrome"

// Connects to data-controller="blocks"
export default class extends Controller {
  connect() {
    if (!document.querySelector('[data-namespace*="blocks/"]')) return;

    this.initAddColumnButtons()
    this.initKeyUpListener()
    this.initAceEditors()
  }

  initAddColumnButtons() {
    document.querySelectorAll(".add_column_fields").forEach(button => {
      button.addEventListener("click", (event) => {
        const parent = button.previousElementSibling.querySelector('.block-columns div')
        parent.insertAdjacentHTML('beforeend', button.dataset.field)

        const inputs = parent.querySelectorAll('input')
        if (inputs.length > 0) {
          inputs[inputs.length - 1].focus()
        }

        event.preventDefault()
      })
    })
  }

  initKeyUpListener() {
    document.addEventListener("keyup", (event) => {
      if (!event.target.matches(".block-columns input")) return

      const input = event.target
      if (input.value === "") {
        const blockColumns = input.closest('.block-columns')
        const inputs = blockColumns.querySelectorAll('input')

        if (inputs.length > 1) {
          const prevInput = input.previousElementSibling
          if (prevInput) prevInput.focus()
          input.remove()
        } else {
          input.style.display = "none"
        }
      }
    })
  }

  initAceEditors() {
    document.querySelectorAll('.ace-editor').forEach(textarea => {
      const editDiv = document.createElement('div')
      textarea.parentNode.insertBefore(editDiv, textarea)
      textarea.style.display = 'none'

      const editor = ace.edit(editDiv)
      editor.renderer.setShowGutter(textarea.dataset.gutter === "true")
      editor.getSession().setValue(textarea.value)
      editor.getSession().setMode("ace/mode/text")
      editor.getSession().setUseWrapMode(true)
      editor.getSession().setUseSoftTabs(false)

      const form = textarea.closest('form')
      if (form) {
        form.addEventListener("submit", () => {
          textarea.value = editor.getSession().getValue()
        })
      }
    })
  }
}
